import { useState } from "react";
import { Link } from "react-router-dom";
import { ArrowRight, Camera, ClipboardList, Info, Layers, Wrench } from "lucide-react";
import { QuoteButton } from "../home/CtaButtons";
import { InspirationCard } from "./InspirationCard";
import { InspirationLightbox } from "./InspirationLightbox";

const WHAT = [
  [ClipboardList, "Uitgangssituatie en wensen", "Welke kozijnen er zaten en wat de bewoners wilden verbeteren."],
  [Layers, "Gekozen systeem en glas", "Materiaal, profielsysteem, kleur en HR++ of HR+++ glas."],
  [Wrench, "Montage en afwerking", "Demontage, plaatsing en de afwerking binnen en buiten."],
  [Camera, "Foto's van het werk", "Echte foto's, waar mogelijk met een voor- en nasituatie."],
];

// Zolang er geen gepubliceerd project is: inspiratie krijgt de aandacht, duidelijk gescheiden van uitgevoerd werk.
export const ProjectsEmpty = ({ block, inspiration = [] }) => {
  const [open, setOpen] = useState(null);
  return (
    <>
      <section aria-labelledby="alvast-inspiratie" className="section" data-testid="projects-empty-state">
        <div className="container-tight">
          <div className="flex flex-col gap-6 lg:flex-row lg:items-end lg:justify-between">
            <div className="max-w-2xl">
              <p className="eyebrow">Inspiratiegalerij</p>
              <h2 id="alvast-inspiratie" className="h2 mt-3" data-testid="projects-empty-title">{block.title}</h2>
              <p className="lead mt-4">{block.body}</p>
            </div>
            <Link to="/projecten/inspiratie" className="btn-primary min-h-[52px] shrink-0 px-6" data-testid="projects-empty-inspiration-cta">
              Bekijk alle inspiratiebeelden <ArrowRight className="h-4 w-4" aria-hidden="true" />
            </Link>
          </div>
          <p className="mt-6 inline-flex items-start gap-2 rounded-xl bg-amber-50 px-3.5 py-2.5 text-[13.5px] text-amber-900" data-testid="projects-inspiration-note">
            <Info className="mt-0.5 h-4 w-4 shrink-0" aria-hidden="true" /> Dit zijn inspiratiebeelden en illustraties, geen projecten die door Maas Kozijn zijn uitgevoerd.
          </p>
          {inspiration.length > 0 && (
            <ul className="mt-8 columns-1 gap-6 sm:columns-2 lg:columns-3" data-testid="projects-inspiration-grid">
              {inspiration.slice(0, 6).map((it) => <InspirationCard key={it.id} it={it} onOpen={setOpen} />)}
            </ul>
          )}
        </div>
      </section>
      <section aria-labelledby="per-project" className="section-tight border-y border-slate-200 bg-slate-50">
        <div className="container-tight">
          <h2 id="per-project" className="h2 max-w-2xl">Wat u per project kunt verwachten</h2>
          <ul className="mt-8 grid gap-4 sm:grid-cols-2 lg:grid-cols-4">
            {WHAT.map(([Icon, t, d]) => (
              <li key={t} className="card p-5">
                <Icon className="h-6 w-6 text-maas" aria-hidden="true" />
                <h3 className="mt-3 text-[16px] font-semibold text-ink">{t}</h3>
                <p className="mt-1.5 text-[14.5px] leading-relaxed text-slate-600">{d}</p>
              </li>
            ))}
          </ul>
          <div className="mt-8"><QuoteButton location="projects-empty" /></div>
        </div>
      </section>
      <InspirationLightbox it={open} onClose={() => setOpen(null)} />
    </>
  );
};
